<!-- 引入数据集弹窗 -->
<template>
  <div class="dataset-popup" v-if="drawerShow" @click="onDrawerShow">
    <div class="dataset-popup-content" @click.stop="">
      <div class="dataset-popup-head">
        <search-box
          :placeholderName="'请输入数据集名称'"
          :buttonShow="false"
          @onSearchKey="GetPageListByName"
          ref="searchKeyRef"
        ></search-box>
      </div>
      <div class="dataset-popup-left-nav">
        <i class="el-icon-close" @click="onDrawerShow"></i>
        <span
          :class="[
            'nav-title',
            activeType == item.id ? 'select-nav-title' : '',
          ]"
          v-for="(item, index) in navList"
          :key="index"
          @click.stop="onClickNav(item.id)"
          >{{ item.label }}</span
        >
      </div>
      <div class="dataset-popup-right-content">
        <div class="tabs-head">
          <div>
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >全选</el-checkbox
            >
            <span class="tabs-head-statistics">{{
              datasetsNumber.num + '/' + datasets.total
            }}</span>
          </div>
          <el-button
            class="tabs-add-button"
            type="primary"
            size="mini"
            @click.stop="onAddDataset"
            >添加</el-button
          >
        </div>
        <el-checkbox-group
          v-model="checkedDatasets"
          @change="handleCheckedCitiesChange"
        >
          <div class="no-data" v-if="datasets.records.length === 0">
            <img :src="emptyImgUrl" alt="">
            <span>{{searchKey ? '未检索到符合条件的数据集' : '暂无数据集'}}</span>
          </div>
          <el-checkbox
            v-for="(item, index) in datasets.records"
            :label="item.datasetId"
            :key="item.datasetId"
          >
            <div class="text-box">
              <span :class="[iconClassFilter(modelType)]"></span>
              <span class="text-title">{{ item.datasetName }}</span>
              <span>{{ item.fileNum }}</span>
            </div>
            <el-divider v-if="index < datasets.records.length - 1"></el-divider>
            <div class="hover-button">
              <el-button
                class="view-details-button"
                type="primary"
                size="mini"
                @click.stop="onToDetails(item.datasetId, item.datasetName)"
                >查看详情</el-button
              >
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import DATASETLOBBY from '@/axios/datasetLobby/datasetLobby.js'

import SearchBox from '@/components/common/SearchBox.vue'

export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'DatasetPopup',
  components: { SearchBox },
  props: {
    // 1图像分类，2图像检测，3文本分类，4文本标注，5音频分类，6音频标注
    modelType: {
      type: String,
      default: '1'
    },
    // 模型数据集名称
    modelDatasetName: {
      type: String,
      default: ''
    },
    // 模型数据集id
    modelDatasetId: {
      type: String,
      default: ''
    },
    // 模型分类标签id
    modelLabelId: {
      type: String,
      default: ''
    },
    drawerShow: {
      type: Boolean,
      default: false
    },
    fileNumAll: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      searchKey: '',
      activeType: '0',
      navList: [
        {
          id: '0',
          label: '公开数据集'
        },
        {
          id: '1',
          label: '个人数据集'
        },
        {
          id: '2',
          label: '我的收藏'
        },
      ],
      checkAll: false,
      checkedDatasets: [], // 选中数据集
      // datasetsOptions: [],
      datasets: {
        records: [],
        current: 1,
        size: 999,
        total: 0,
      },
      isIndeterminate: false,
      datasetsNumber: {
        selecteNumber: 0,
        num: 0,
      },
      emptyImgUrl: require('../../assets/images/datasetLobby/icon-empty-box.png'),
      clickFlag: false,
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    drawerShow(val) {
      if (val) {
        // 查询引用数据集列表
        this.getQuoteDatasetList(1)
      }
    },
    checkedDatasets(val) {
      this.datasetsNumber.num = val.length || 0
      this.datasetsNumber.selecteNumber = 0
      if (val && val.length) {
        let list = val
        list.forEach(i => {
          this.datasets.records.forEach(item => {
            if (i === item.datasetId) {
              this.datasetsNumber.selecteNumber += item.fileNum
            }
          });
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  methods: {
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    iconClassFilter(datasetType) {
      if (datasetType == 1 || datasetType == 2) {
        return 'el-icon-img'
      } else if (datasetType == 3 || datasetType == 4) {
        return 'el-icon-txt'
      } else if (datasetType == 5 || datasetType == 6) {
        return 'el-icon-audio'
      }
    },
    // 查询引用数据集列表
    getQuoteDatasetList(pageNum) {
      let data = {
        searchType: this.activeType, // 搜索类型：0公开数据，1个人上传，2个人收藏
        datasetName: this.searchKey, // 数据集名称
        datasetType: this.modelType, // 数据集类型：1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
        pageNum: pageNum,
        pageSize: 999,
      }
      DATASETLOBBY.getQuoteDatasetList(data).then((result) => {
        if (result.isSuccess) {
          this.datasets = result.data
        } else {
          this.datasets = {
            records: [],
            current: 1,
            size: 999,
            total: 0,
          }
          this.$message.error(res.returnMsg)
        }
        // 变量初始状态
        this.initialState()
        this.this.clickFlag = false
      }).catch(() => {
        // 变量初始状态
        this.initialState()
        this.clickFlag = false
      });
    },
    // 变量初始状态
    initialState() {
      this.checkAll = false
      this.isIndeterminate = false
      this.checkedDatasets = []
      this.datasetsNumber = {
        selecteNumber: 0,
        num: 0,
      }
    },
    // 左侧数据集tab栏
    onClickNav(type) {
      this.activeType = type
      this.searchKey = ""; // 初始化搜索关键字
      this.$refs.searchKeyRef.onSearchKeyText() // 搜索关键字置空
      // 查询引用数据集列表
      this.getQuoteDatasetList(1)
    },
    // 全选、全不选
    handleCheckAllChange(val) {
      if (val) {
        let datasetIdList = []
        this.datasets.records.forEach(item => {
          datasetIdList.push(item.datasetId)
        });
        this.checkedDatasets = datasetIdList
      } else {
        this.checkedDatasets = []
      }
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.datasets.records.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.datasets.records.length;
    },
    // 搜索
    GetPageListByName(key) {
      this.searchKey = key
      this.getQuoteDatasetList(1);
    },
    // 添加引用数据集
    onAddDataset() {
      let checkedDatasets = JSON.parse(JSON.stringify(this.checkedDatasets))
      if (checkedDatasets.length === 0) {
        return this.$message.error('请先勾选需要添加的数据集!')
      }

      // let modelType = this.modelType,
      //   flangNum = modelType == 1 || modelType == 3 || modelType == 5 ? 200 : 3000
      // if ((this.fileNumAll + this.datasetsNumber.selecteNumber) > flangNum) {
      //   let msg =
      //     modelType == 1 || modelType == 3 || modelType == 5 ?
      //       `单个分类标签的${this.modelTypeCompany(modelType)}总数不超过 200个 ，请重新选择哦~` :
      //       `单个数据集的${this.modelTypeCompany(modelType)}总数不超过 3000个，请重新选择哦~`;
      //   return this.$message.error(msg)
      // }

      // let flag = false
      // checkedDatasets.forEach(id => {
      //   this.datasets.records.forEach(itm => {
      //     if (id === itm.datasetId && itm.fileNum == 0) {
      //       flag = true
      //       this.$message.error(`${itm.datasetName}该数据集暂无${this.modelTypeCompany(modelType)}!`);
      //     }
      //   });
      // });
      // if (flag && checkedDatasets.length === 1) {
      //   return
      // }

      if (this.clickFlag) { // 判断连接点击多次只执行第一次
        return
      }
      this.clickFlag = true

      let data = {
        datasetHallType: this.activeType, // 数据集大厅类型：0公开数据，1个人上传，2个人收藏
        datasetId: this.modelDatasetId, // 目标数据集id
        datasetType: this.modelType, // 数据集类型
        labelId: this.modelLabelId, // 分类标签id
        list: checkedDatasets, // 被引用的数据集id集合
        modFileNum: this.fileNumAll, // 目标数据集文件数
      }

      DATASETLOBBY.quoteDataset(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg);
          // 刷新模型训练文件列表
          this.$emit('getPictureList');
          // 查询引用数据集列表
          this.getQuoteDatasetList(1);
        } else {
          this.$message.error(result.returnMsg)
          if (result.returnCode === 501) { // 数据集不存在
            // 查询引用数据集列表
            this.getQuoteDatasetList(1);
          }
        }
      }).catch(() => {
        this.clickFlag = false
      });
    },
    // 查看数据集大厅-数据集详情
    onToDetails(datasetId, datasetName) {
      // 跳转数据集详情页
      this.$router.push({
        name: "dataset-preview",
        query: {
          searchType: this.activeType, // nav类型：0公开数据集，1个人数据集，2我的数据集
          datasetId: datasetId, // 当前数据集id
          datasetName: datasetName, // 当前数据集名称
          datasetType: this.modelType, // 数据集类型：1图像分类，2图像检测，3文本分类，4文本标注，5音频分类，6音频标注
          isAdd: 1, // 增加一次查看数：0不增，1增加
          datasetPageType: 2, // 数据页面类型：0数据大厅,1数据大厅详情，2引用数据集详情
          modelDatasetName: this.modelDatasetName, // 模型/目标数据集名称
          modelDatasetId: this.modelDatasetId, // 模型/目标数据集id
          labelId: this.modelLabelId, // 分类标签id
          modFileNum: this.fileNumAll, // 目标数据集文件数
        }
      });
    },
    // 关闭引用数据集弹窗
    onDrawerShow() {
      this.$emit('onDrawerShow')
      this.activeType = '0'
      // 变量初始状态
      this.initialState()
    }
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.dataset-popup {
  width: 100%;
  height: 100%;
  min-height: 600px;
  background-color: rgba($color: #000000, $alpha: 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  .dataset-popup-content {
    width: 300px;
    height: calc(100% - 80px);
    background-color: #fff;
    border: 1px solid #e6e9f2;
    padding: 20px 0 0;
    position: absolute;
    top: 80px;
    right: 0;
    margin: auto 0;
    .dataset-popup-head {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      /deep/.el-input__inner {
        height: 36px;
        border-radius: 18px;
      }
    }
    .dataset-popup-left-nav {
      width: 36px;
      position: absolute;
      top: -1px;
      left: -36px;
      display: flex;
      flex-direction: column;
      .el-icon-close {
        color: rgb(160, 160, 160);
        // width: 36px;
        height: 36px;
        background: #ffffff;
        font-size: 16px;
        font-weight: 700;
        border: 1px solid #e6e9f2;
        border-radius: 100px 0px 0px 100px;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
        &:hover {
          color: rgba(118, 138, 184, 1);
        }
      }
      .nav-title {
        width: 36px;
        height: 100px;
        background: #ffffff;
        color: #919bb3;
        line-height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        border: 1px solid #e6e9f2;
        border-radius: 20px 0px 0px 20px;
        box-sizing: border-box;
        padding: 9px 9px 10px 11px;
        word-break: break-all;
        cursor: pointer;
        &:hover {
          color: rgba(118, 138, 184, 1);
        }
        &:last-child {
          padding: 15px 10px;
        }
      }
      .select-nav-title {
        color: #4c88ff;
        &:hover {
          color: #4c88ff;
        }
      }
    }

    .dataset-popup-right-content {
      width: 100%;
      height: calc(100% - 40px);
      // overflow: hidden;
      /deep/.el-tabs__nav {
        white-space: pre-wrap;
      }
      /deep/ .el-tabs__item {
        width: 30px;
        height: 80px;
        line-height: 14px;
        padding: 5px;
        text-align: center;
      }
      /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
      /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #4c88ff;
        border-color: #4c88ff;
      }
      .tabs-head {
        color: #919bb3;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        .el-checkbox {
          /deep/.el-checkbox__label {
            color: #919bb3;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            padding-left: 5px;
          }
        }
        .tabs-head-statistics {
          display: inline-block;
          font-size: 10px;
          margin-left: 6px;
        }
        /deep/.tabs-add-button {
          width: 42px;
          height: 20px;
          line-height: 20px;
          font-size: 10px;
          background: #4c88ff;
          border: 1px solid #4c88ff;
          border-radius: 6px;
          padding: 0;
        }
      }
      .el-checkbox-group {
        height: calc(100% - 40px);
        display: flex;
        flex-direction: column;
        overflow: auto;
        padding-bottom: 20px;
        &::-webkit-scrollbar {
          width: 8px; /*滚动条宽度*/
          height: 8px; /*滚动条高度*/
        }
        /*定义滚动条轨道 内阴影+圆角*/
        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
          background: rgba(0, 96, 255, 0.1); /*滚动条的背景颜色*/
          border-radius: 10px; /*滚动条的背景区域的圆角*/
        }
        /*定义滑块 内阴影+圆角*/
        &::-webkit-scrollbar-thumb {
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
          background: rgba(0, 96, 255, 0.3); /*滚动条的背景颜色*/
          border-radius: 10px; /*滚动条的圆角*/
        }

        .no-data {
          color: rgb(145, 144, 144);
          width: 300px;
          height: 160px;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            width: 134px;
            height: 80px;
          }
          span {
            color: #BDC3D2;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            margin-top: 16px;
          }
        }

        .el-checkbox {
          width: 100%;
          display: flex;
          align-items: center;
          padding: 10px 20px;
          margin: 5px 0;
          position: relative;
          box-sizing: border-box;
          &:hover {
            /deep/.el-checkbox__label .hover-button {
              display: block;
            }
          }
          /deep/.el-checkbox__label {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-left: 12px;
            .text-box {
              flex: 1;
              span {
                float: left;
                &:first-child {
                  width: 44px;
                  height: 44px;
                  background-color: #4c88ff;
                  border: 1px solid #4c88ff;
                  border-radius: 50%;
                  margin-right: 8px;
                  overflow: hidden;
                }
                &:last-child {
                  width: 170px;
                  color: rgb(160, 160, 160);
                }
              }
              .el-icon-img {
                background: url('../../assets/images/datasetLobby/type-img.png')
                  no-repeat;
                background-size: 100% 100%;
              }
              .el-icon-txt {
                background: url('../../assets/images/datasetLobby/type-txt.png')
                  no-repeat;
                background-size: 100% 100%;
              }
              .el-icon-audio {
                background: url('../../assets/images/datasetLobby/type-audio.png')
                  no-repeat;
                background-size: 100% 100%;
              }
              .text-title {
                color: #333;
                width: 170px;
                margin-top: 5px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            .el-divider {
              width: 180px;
              position: absolute;
              right: 20px;
              bottom: -30px;
            }
            .hover-button {
              display: none;
              width: 100%;
              height: 100%;
              background: linear-gradient(
                270deg,
                rgba(76, 136, 255, 0.6) 0%,
                rgba(76, 136, 255, 0) 100%
              );
              position: absolute;
              top: 0;
              right: 0;
              z-index: 1;
              .view-details-button {
                width: 72px;
                height: 28px;
                background: #ffffff;
                border: 1px solid #fff;
                border-radius: 14px;
                color: #4c88ff;
                font-size: 12px;
                font-weight: 600;
                padding: 5px;
                text-align: center;
                position: absolute;
                top: 0;
                right: 20px;
                bottom: 0;
                margin: auto 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
